<template>
    <div class="w-100" >
        <template v-if="message.isClient">
            <div class="leftContainer">
                <div class="message">
                    <div style="display: inline-block;">{{ message.message }}<span class="mesDate">{{ formatTime(message.messageDate) }}</span></div>
                </div>
            </div>
        </template>
        <template v-else >
            <div class="rightContainer">
                <div class="userMessage">
                    <div style="display: inline-block;">{{ message.message }}<span class="mesDate">{{ formatTime(message.messageDate) }}</span></div>
                </div>
            </div>


        </template>
    </div>
</template>

<script>
    export default {
        props:["message"],
        name: "ChatsMessage",

    }
</script>

<style >
    .leftContainer{
       text-align: left;
        margin: 20px;
    }

    .rightContainer{
        text-align: right;
        margin: 20px;
    }
    .mesDate{
        font-size: 12px;
        line-height: 15px;
        margin-left:10px;
        color: #6E7C8D;
    }
    .message{
        max-width: 75%;
        position: relative;
        display: inline-block;
        word-wrap: break-word;
        padding: 5px;
        border-radius:5px;
        color: #1A2A3A;
        background-color: #FFFFFF;
    }

    .message:before{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: -10px;
        bottom: 0px;
        border: 7px solid;
        border-color: transparent #FFFFFF #FFFFFF transparent;
    }

    .userMessage{
        max-width: 75%;
        position: relative;
        display: inline-block;
        word-wrap: break-word;
        text-align: left;
        padding: 5px;
        border-radius:5px;
        color: #1A2A3A;
        background-color: #F2F7FA;
    }

    .userMessage:after{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        right: -10px;
        bottom: 0px;
        border: 7px solid;
        border-color: transparent transparent #F2F7FA  #F2F7FA ;
    }
</style>